<form [formGroup]="setPasswordFrom" (ngSubmit)="onSubmit()">
  <orbit-form-field
    [autocomplete]="false"
    [inputType]="'password'"
    [label]="'SHARED.LOGIN.PASSWORD_LABEL' | translate"
    [name]="'password'"
    [testId]="'input-set-password'"
    [controller]="password" />
  <orbit-form-field
    [autocomplete]="false"
    [inputType]="'password'"
    [label]="'SHARED.SET_PASSWORD.CONFIRM_PASSWORD' | translate"
    [name]="'confirmPassword'"
    [testId]="'input-confirm-password'"
    [controller]="confirmPassword" />
  <orbit-button
    [label]="'SHARED.SET_PASSWORD.SET_PASSWORD' | translate"
    [inputId]="'reset-password-button'"
    [testId]="'btn-set-password-submit'"
    type="submit"
    class="w-full"
    styleClass="w-full"
    size="large" />
  @if (errorMessage) {
    <orbit-message
      [message]="errorMessage"
      [severity]="'error'"
      [titleTestId]="'error-set-password-title-form'"
      [messageTestId]="'error-set-password-message-form'" />
  }
</form>
